function AdminCustomProfileStatusBadge(props) {
  const profile = getAdminCustomProfileItem(
    props.customProfiles,
    props.channelType,
  );
  const mode = _.get(profile, "custom_admin_name_mode") || "default";
  const lang = props.lang;
  const modeLabels = {
    default: lang.__setting_admin_custom_profile_mode_default || "RMP Profile",
    custom: lang.__setting_admin_custom_profile_mode_custom || "Custom",
    disabled: lang.__setting_admin_custom_profile_mode_disabled || "LINE OA",
  };
  const statusLabel = modeLabels[mode] || modeLabels.default;

  return (
    <div
      className={
        "admin-custom-profile-status-badge" +
        (mode === "disabled" ? " -disabled" : " -configured")
      }
    >
      <span className="admin-custom-profile-status-label">{statusLabel}</span>
    </div>
  );
}
